import { render, staticRenderFns } from "./Simple.vue?vue&type=template&id=da6f9372&"
import script from "./Simple.vue?vue&type=script&lang=ts&"
export * from "./Simple.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports